/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  sessionId: string
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  userName: string
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  password: string
}

/**
 * Check if a given object implements the LoginRequest interface.
 */
export function instanceOfLoginRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'userName' in value
  isInstance = isInstance && 'password' in value

  return isInstance
}

export function LoginRequestFromJSON(json: any): LoginRequest {
  return LoginRequestFromJSONTyped(json, false)
}

export function LoginRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LoginRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    userName: json['user_name'],
    password: json['password'],
  }
}

export function LoginRequestToJSON(value?: LoginRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    user_name: value.userName,
    password: value.password,
  }
}
